import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';
// import dayjs from 'src/libs/dayjs';
import history from 'src/libs/history';
import { PATH } from 'src/constants/app';

export type State = {
  loading: boolean;
};

export const DirectoryFilter = {
  Mentors: 'mentors',
  Experts: 'experts',
  Alumni: 'alumni',
} as const;

export const adapter = createEntityAdapter<Model.Role>({
  // selectId: (model) => model.id,
  // sortComparer: (a, b) => {
  //   return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? -1 : 1;
  // },
});

const { reducer, actions } = createSlice({
  name: 'roles',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Role[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Role>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.role,
);

export const selectRolesWithSearch = createSelector(
  selector.selectAll,
  (state: RootState) => state.ui.menu.data[PATH.DIRECTORY],
  (roles, menu) => {
    const menuItem = (key: string) => menu?.find((m) => m.key === key);
    const role = history.location.pathname.split('/')[2];

    if (role === DirectoryFilter.Alumni) {
      return {
        role_id: roles.find((r) => r.name === 'Alumni')?.id,
        title: menuItem(DirectoryFilter.Alumni)?.content,
        role,
      };
    }
    if (role === DirectoryFilter.Mentors) {
      return {
        role_id: roles.find((r) => r.name === 'Mentor')?.id,
        title: menuItem(DirectoryFilter.Mentors)?.content,
        role,
      };
    }
    if (role === DirectoryFilter.Experts) {
      return {
        role_id: roles.find((r) => r.name === 'Expert')?.id,
        title: menuItem(DirectoryFilter.Experts)?.content,
        role,
      };
    }

    return {
      role_id: undefined,
      title: menuItem('undefined')?.content,
    };
  },
);

export { reducer };
export default actions;
